


<ng-template #rt let-r="result" let-t="term">
  @if (showStatus) {
<app-speaker-list-item [name]="r.prenom + ' ' + r.nom" (selectEvent)="this.onSelectSpeaker($event)" [speaker]="r" [status]="this.getStatus(r)" />
}
  @if (!showStatus) {
<app-speaker-list-item [name]="r.prenom + ' ' + r.nom" (selectEvent)="this.onSelectSpeaker($event)" [speaker]="r" />
}
</ng-template>

<div class="form-floating">
    <input
      id="typeahead-template"
      type="text"
      class="form-control col"
      [(ngModel)]="model"
      [ngbTypeahead]="search"
      [resultTemplate]="rt"
      placeholder=""
      [disabled]="this.disabled"
      aria-describedby="soustitre"
      (selectItem)="this.onSelectSpeaker($event.item)"
    />
    <label class="form-label" for="typeahead-template">{{label}}</label>
  @if (displayStatus && legendStatut) {
<small  id="soustitre" class="form-text text-muted ms-1">{{legendStatut}}</small>
}

</div>
